import { render, staticRenderFns } from "./ZigBeeWirelessGateway.vue?vue&type=template&id=f491de82&scoped=true&"
import script from "./ZigBeeWirelessGateway.vue?vue&type=script&lang=js&"
export * from "./ZigBeeWirelessGateway.vue?vue&type=script&lang=js&"
import style0 from "./ZigBeeWirelessGateway.vue?vue&type=style&index=0&id=f491de82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f491de82",
  null
  
)

export default component.exports